import { render, staticRenderFns } from "./dialogos.vue?vue&type=template&id=4aeaa44e&scoped=true&"
import script from "./dialogos.vue?vue&type=script&lang=js&"
export * from "./dialogos.vue?vue&type=script&lang=js&"
import style0 from "./dialogos.vue?vue&type=style&index=0&id=4aeaa44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeaa44e",
  null
  
)

export default component.exports